import request from '../utils/request';
import { API_ENDPOINTS } from '../config/api';

export const authService = {
  login: (params) => {
    return request.post(API_ENDPOINTS.LOGIN, params);
  },
  
  getProfile: () => {
    return request.get(API_ENDPOINTS.PROFILE);
  },
  
  /**
   * 刷新token
   */
  refreshToken: (refreshToken) => {
    // 刷新token的逻辑已经在request.js中实现
    // 这里保留接口以保持一致性，但实际不会使用
    return request.post('/admin/auth/refresh', { refreshToken });
  },
  
  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    window.location.href = '/login';
  },
};

